import type { AircraftModelId } from '../../../types';

type ModelLabelStrings = {
    MODEL_EXEDY_V12: string;
    MODEL_EXEDY_V9: string;
};

export const getModelLabels = (strings: ModelLabelStrings): Record<AircraftModelId, string> => ({
    exedyV9: strings.MODEL_EXEDY_V9,
    exedyV12: strings.MODEL_EXEDY_V12
});
